'use strict';

var rgba2hex = require('../pdf/rgbaToHex');
var colors = require('./chartsColors');
require('./chartsConfig');

function adjustLegendSymbolRadius (chart, radius) {
  // changes the radius of the symbol in the legend after the chart is created
  // This functionality is not part of the highchrts API
  $(chart.series).each(function (i, series) {
    var originalRadius = series.legendSymbol.attr('width') / 2;
    var originalX = series.legendSymbol.attr('x');
    var originalY = series.legendSymbol.attr('y');

    series.legendSymbol.attr('width', radius * 2);
    series.legendSymbol.attr('height', radius * 2);
    series.legendSymbol.attr('x', originalX + originalRadius - radius);
    series.legendSymbol.attr('y', originalY + originalRadius - radius);
  });
}

function renderLineChart ($part, data) {
  var chart;
  var chartConfig = window.buildChartConfig('line', {
    chart: {
      renderTo: $part.get(0)
    },
    series: data
  });

  chart = new window.Highcharts.Chart(chartConfig);
  return adjustLegendSymbolRadius(chart, 5);
}

function renderPieChart ($part, data) {
  var chartConfig = window.buildChartConfig('pie', {
    chart: {
      renderTo: $part.get(0),
      height: $part.width() > 500 ? 130 : 190
    },
    series: [
      {
        type: 'pie',
        data: data
      }
    ],
    legend: {
      verticalAlign: $part.width() > 500 ? 'middle' : 'bottom'
    }
  });

  return new window.Highcharts.Chart(chartConfig);
}

function renderGenderAgeChart ($part, data) {
  var chartConfig = window.buildChartConfig('gender-age-chart', {
    chart: {
      renderTo: $part.get(0)
    },
    series: data
  });

  return new window.Highcharts.Chart(chartConfig);
}

function renderGeoChart ($part, data) {
  var $map = $('<div>')
    .addClass('woomap')
    .css({
      width: '100%',
      height: '330px'
    });

  $part.append($map);

  var mapColors = window.mapColors;
  var defaultColor = colors.primaryDarker;
  var primaryColor;
  var secondaryColor;
  var r;
  var g;
  var b;

  if (mapColors) {
    primaryColor = window.mapColors[0];
    secondaryColor = window.mapColors[100];
  } else {
    r = parseInt(defaultColor[1] + defaultColor[2], 16);
    g = parseInt(defaultColor[3] + defaultColor[4], 16);
    b = parseInt(defaultColor[5] + defaultColor[6], 16);
    primaryColor = rgba2hex(r, g, b, 0.09);
    secondaryColor = defaultColor;
  }

  $map.bind('regionMouseOver.jqvmap', function (event) {
    return event.preventDefault();
  });

  $map.height(($map.height() + 40) + 'px');

  $map.vectorMap({
    map: 'world_en',
    backgroundColor: colors.white,
    color: colors.greylight,
    scaleColors: [primaryColor, secondaryColor],
    values: data,
    borderColor: colors.white,
    borderWidth: 1,
    borderOpacity: 1,
    hoverColor: colors.primary,
    selectedColor: colors.primaryDarker,
    enableZoom: false,
    showTooltip: false
  });
}

function renderChart ($part, data, type) {
  var chart;
  var chartConfig = window.buildChartConfig(type, $.extend(true, {
    chart: {
      renderTo: $part.get(0)
    }
  }, data));

  chart = new window.Highcharts.Chart(chartConfig);
  return chart;
}

window.Highcharts.setOptions({
  plotOptions: {
    series: {
      animation: false
    }
  }
});

module.exports = {
  line: renderLineChart,
  pie: renderPieChart,
  genderAge: renderGenderAgeChart,
  geo: renderGeoChart,
  render: renderChart
};
